import { useDispatch } from 'react-redux'

export const useWalletsActions = () => {
  const dispatch = useDispatch()

  const getWallets = () => {
    dispatch({ type: 'WALLETS/FETCH_WALLETS' })
  }

  const setActiveWalletID = (props) => {
    dispatch({ type: 'WALLETS/CHANGE_ACTIVE_WALLET_ID', payload: props })
  }

  const getPromisedPayments = () => {
    dispatch({ type: 'WALLETS/FETCH_WALLET_PROMISED_PAYMENTS' })
  }

  const getWalletTransactions = (props) => {
    dispatch({ type: 'WALLETS/FETCH_WALLET_TRANSACTIONS', payload: props })
  }

  const resetWallets = () => {
    dispatch({ type: 'WALLETS/RESET_WALLETS' })
  }

  const refetchWalletTransaction = (props) => {
    dispatch({
      type: 'WALLETS/REFETCH_WALLET_TRANSACTIONS',
      payload: props,
    })
  }

  const refetchWalletPromisedPayments = (props) => {
    dispatch({
      type: 'WALLETS/REFETCH_WALLET_PROMISED_PAYMENTS',
      payload: props,
    })
  }

  const resetTransactions = () => {
    dispatch({ type: 'WALLETS/RESET_WALLET_TRANSACTIONS' })
  }

  const fetchExpiredPromisedPayments = (props) => {
    dispatch({ type: 'WALLETS/FETCH_EXPIRED_PAYMENTS', payload: props })
  }

  return {
    getWallets,
    setActiveWalletID,
    getPromisedPayments,
    fetchExpiredPromisedPayments,
    refetchWalletTransaction,
    refetchWalletPromisedPayments,
    getWalletTransactions,
    resetWallets,
    resetTransactions,
  }
}
